package com.tixforgigs.common.core.models.ui

data class InputState<T>(
  val inputValue: T,
  val isValid: Boolean
)
